export default {
    topics: [
        {
            title: ' ProcessCreationTask ',
            href: 'sm-localValidationTask-ProcessCreationTask.html',
            attributes: { 'data-id': 'sm-localValidationTask-ProcessCreationTask' },
            menu: { hasChildren: false },
            tocID: 'sm-localValidationTask-ProcessCreationTask-d66e3173',
            topics: [],
        },
    ],
};

